import ParseUtils from "../utils/parse-utils.ts";

export default class Coordinates {
  public readonly latitude: number;
  public readonly longitude: number;

  constructor(latitude: number, longitude: number) {
    this.latitude = latitude;
    this.longitude = longitude;
  }

  public static fromPayload(payload: Record<string, unknown>): Coordinates {
    const latitude: number = ParseUtils.parseNumber(payload, "latitude");
    const longitude: number = ParseUtils.parseNumber(payload, "longitude");
    return new Coordinates(latitude, longitude);
  }
}
